export { DeladdressAction } from 'next-flight-server-reference-proxy-loader?id=7f367ef51c4ff1360ca97b5a0570f70317b706b20f&name=DeladdressAction!'